import { useMutation as useMutationClient } from 'react-query';
import type { UseMutationOptions } from 'react-query/types';
import type { MutationKey } from 'react-query/types/core';

const useMutation = <
  TVariables = unknown,
  TResponse = unknown,
  TError = unknown
>(
  mutationKey: MutationKey,
  options: UseMutationOptions<TResponse, TError, TVariables> = {}
) => {
  const { mutate, mutateAsync, ...rest } = useMutationClient<
    TResponse,
    TError,
    TVariables
  >(options);
  return {
    mutate: (variables: TVariables) => mutate({ mutationKey, ...variables }),
    mutateAsync: (variables: TVariables) =>
      mutateAsync({ mutationKey, ...variables }),
    ...rest,
  };
};

export default useMutation;
